const VERSION = "4.0.1";
export {
  VERSION
};
